export function parseOrgConfigBoolean(value: string | undefined, defaultValue = false): boolean {
  const normalized = String(value ?? '').toLowerCase();
  if (['1', 't', 'true'].includes(normalized)) {
    return true;
  }
  if (['0', 'f', 'false'].includes(normalized)) {
    return false;
  }
  return defaultValue;
}
